import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";

import { CustomTabs } from "../../../components";
import DataChart from "./components/DataChart";
import Report from "./components/Report";

function ProductReport() {
  const [activeTab, setActiveTab] = useState("data");
  const { t } = useTranslation();
  const [params] = useSearchParams();

  const onTabChange = (key) => {
    setActiveTab(key);
  };

  const getNowTab = () => {
    const tab = params.get("tab");
    if (tab) {
      const foundTab = tabItems.find((item) => item.key == tab);
      if (foundTab) {
        setActiveTab(tab);
      } else {
        setActiveTab(tabItems[0].key);
      }
    } else {
      setActiveTab(tabItems[0].key);
    }
  };

  const tabItems = [
    {
      key: "data",
      title: t("mobile.home.menu.productData"),
      component: <DataChart />,
      destroyOnClose: true,
    },
    {
      key: "report",
      title: t("mobile.home.menu.productReport"),
      component: <Report activeTab={activeTab} />,
      destroyOnClose: true,
    },
  ];

  const componentDict = {
    data: <DataChart />,
    report: <Report />,
  };

  useEffect(() => {
    getNowTab();
  }, []);

  return (
    <div>
      <CustomTabs
        activeKey={activeTab}
        onTabChange={onTabChange}
        tabItems={tabItems}
      />
      {/* {componentDict[activeTab]} */}
    </div>
  );
}

export default ProductReport;
